import React from "react";
import { usePageMeta } from "@/hooks/usePageMeta";

export default function SubscriptionTerms() {
  usePageMeta({ title: "Subscription Terms & Refunds - The Cardlight", description: "Premium billing, automatic renewal, cancellation and refund terms for The Cardlight: $7.99/month or $59.99/year, 12 readings a month.", path: "/terms" });
  return (
    <article className="mx-auto max-w-3xl px-5 py-12 text-[#F8F3E6] sm:px-8">
      <p className="text-xs uppercase tracking-[0.2em] text-[#E5C365]">The Cardlight</p>
      <h1 className="mt-3 font-display text-3xl font-semibold sm:text-4xl">
        Subscription Terms
      </h1>
      <p className="mt-3 text-sm text-[#A3A5B8]">Effective October 6, 2026</p>
      <p className="mt-6 leading-relaxed">
        These terms explain Premium billing, cancellation, and refunds for The
        Cardlight, offered by White Raven Holistic.
      </p>

      <section className="mt-8 space-y-3" aria-labelledby="plans-heading">
        <h2 id="plans-heading" className="font-display text-2xl text-[#E5C365]">
          Plans and automatic renewal
        </h2>
        <p className="leading-relaxed">
          Premium is $7.99 per month for the monthly plan or $59.99 per year for
          the annual plan, in US dollars. The annual plan is billed as one yearly
          payment. Your subscription automatically renews on the same billing
          schedule unless you cancel before the next renewal.
        </p>
        <p className="leading-relaxed">
          Both plans include 12 full AI readings per month, with up to 3 follow-up
          questions per reading. Annual subscribers receive 12 readings each
          month, rather than 144 readings at once. Unused readings do not roll
          over. Daily Ritual and follow-up questions do not use full-reading
          credits. Deleting a reading does not restore its credit.
        </p>
      </section>

      <section className="mt-8 space-y-3" aria-labelledby="cancel-heading">
        <h2 id="cancel-heading" className="font-display text-2xl text-[#E5C365]">
          Cancel anytime
        </h2>
        <p className="leading-relaxed">
          To cancel, sign in to The Cardlight, select your Premium badge, and use
          the cancellation option in the Stripe billing portal. Cancel before
          your next renewal to stop the next recurring charge.
        </p>
        <p className="leading-relaxed">
          Your Premium access continues until the end of your current paid billing
          period, subject to the monthly reading allowance. For a monthly plan,
          that is the end of the paid month; for an annual plan, it is the end of
          the paid year. Your subscription will not renew after cancellation.
        </p>
      </section>

      <section className="mt-8 space-y-3" aria-labelledby="refund-heading">
        <h2 id="refund-heading" className="font-display text-2xl text-[#E5C365]">
          Refunds and billing errors
        </h2>
        <p className="leading-relaxed">
          Cancellation alone does not refund the current monthly or annual
          payment. We do not provide prorated refunds for unused time or readings,
          except where required by law.
        </p>
        <p className="leading-relaxed">
          If you believe a charge was incorrect or duplicated, email{" "}
          <a href="mailto:support@thecardlight.com" className="text-[#E5C365] underline underline-offset-4" data-testid="terms-support-email">support@thecardlight.com</a>{" "}
          so we can review it.
        </p>
      </section>
    </article>
  );
}
